export default {
  new: {
    key: 'new', 
    name : '现价', 
    fromQuote : true,
    format (v,tr) {
      let chf = tr['zhangdiefu'];
      if(v == 'NUL' || v === '' || v === void 0) {
        return '<div style="text-align:right;width: 60px;margin:0 auto;color:#bdbdbd">--</div>'
      }else if(chf && chf >= 0){
        return '<div style="text-align:right;width: 60px;margin:0 auto;color:#ff3232">' + Number(v).toFixed(2) + '</div>';
      }else {
        return '<div style="text-align:right;width: 60px;margin:0 auto;color:#00e600">' + Number(v).toFixed(2) + '</div>';
      }
    }
  },
  new_c: {
    key: 'new', 
    name : '现价', 
    fromQuote : true,
    format (v,tr) {
      let chf = tr['zhangdiefu'];
      if(v == 'NUL' || v === '' || v === void 0) {
        return '<div style="text-align:right;width: 60px;margin:0 auto;" class="c-default">--</div>'
      }else if(chf && chf >= 0){
        return '<div style="text-align:right;width: 60px;margin:0 auto;" class="c-red">' + Number(v).toFixed(2) + '</div>';
      }else {
        return '<div style="text-align:right;width: 60px;margin:0 auto;" class="c-green">' + Number(v).toFixed(2) + '</div>';
      }
    }
  },
  zdf: {
    name: '涨幅',
    key: 'zhangdiefu',
    fromQuote: true,
    format : function(v, code){
      if(v == 'NUL' || v === '' || v === void 0) {
        return '<div style="text-align:right;width: 55px;margin:0 auto;color:#bdbdbd">--</div>'
      }else if(v >= 0){
        return '<div style="text-align:right;width: 55px;margin:0 auto;color:#ff3232">+' + Number(v).toFixed(2) + '%</div>';
      }else {
        return '<div style="text-align:right;width: 55px;margin:0 auto;color:#00e600">' + Number(v).toFixed(2) + '%</div>';
      }
    }
  },
  zdf_c: {
    name: '涨幅',
    key: 'zhangdiefu',
    fromQuote: true,
    format : function(v, code){
      if(v == 'NUL' || v === '' || v === void 0) {
        return '<div style="text-align:right;width: 55px;margin:0 auto;" class="c-default">--</div>'
      }else if(v >= 0){
        return '<div style="text-align:right;width: 55px;margin:0 auto;" class="c-red">+' + Number(v).toFixed(2) + '%</div>';
      }else {
        return '<div style="text-align:right;width: 55px;margin:0 auto;" class="c-green">' + Number(v).toFixed(2) + '%</div>';
      }
    }
  },
  fixed2: {format: function(v) {return v ? Number(v).toFixed(2) : '--'}}
}


// WEBPACK FOOTER //
// ./src/lib/v-hqtable/lib/formula.js